import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const hadiahRetailerModule = () => import('./hadiah-retailer.module').then((m) => m.HadiahRetailerModule);

// Top-level. Sebelumnya "Hadiah Retailer" adalah child dari Reward Setting
// (enum REWARD_RETAILER) — dipromosikan jadi parent sendiri supaya
// Hadiah Naik Level bisa punya grandchild (List Klaim/Pencairan Klaim/
// LPJ Klaim/List Hadiah) tanpa melebihi 3 level yang didukung sidebar.
export const hadiahRetailerRoutes: Routes = [
  {
    path: 'hadiah-retailer',
    canActivateChild: [RoleGuard],
    loadChildren: hadiahRetailerModule,
    data: {
      enum: 'HADIAH_RETAILER',
      label: 'Hadiah Retailer',
      icon: 'ic_box_reward.svg',
      activeClass: 'active',
      children: [
        {
          // enum HARUS 'REWARD_PRODUCT' (bukan label 'HADIAH_SCAN_QR') — privilege asli yang sudah
          // dipakai RoleGuard di hadiah-retailer-routing.module.ts (scan-qr/list, scan-qr/form).
          enum: 'REWARD_PRODUCT',
          label: 'Hadiah Scan QR',
          path: 'hadiah-retailer/scan-qr',
          children: [
            {
              enum: 'LIST_REWARD',
              label: 'List Reward',
              path: 'hadiah-retailer/scan-qr/list',
              children: [],
            },
            {
              enum: 'CREATE_REWARD',
              label: 'Tambah Reward',
              path: 'hadiah-retailer/scan-qr/form',
              children: [],
            },
          ],
        },
        {
          enum: 'HADIAH_NAIK_LEVEL',
          label: 'Hadiah Naik Level',
          path: 'hadiah-retailer/naik-level',
          children: [
            {
              enum: 'LIST_KLAIM_NAIK_LEVEL',
              label: 'List Klaim',
              path: 'hadiah-retailer/naik-level/list-klaim',
              children: [],
            },
            {
              enum: 'PENCAIRAN_KLAIM_NAIK_LEVEL',
              label: 'Pencairan Klaim',
              path: 'hadiah-retailer/naik-level/pencairan-klaim',
              children: [],
            },
            {
              enum: 'LPJ_KLAIM_NAIK_LEVEL',
              label: 'LPJ Klaim',
              path: 'hadiah-retailer/naik-level/lpj-klaim',
              children: [],
            },
            {
              // enum HARUS 'REWARD_RETAILER' (bukan 'LIST_HADIAH_NAIK_LEVEL') — samakan dengan enum
              // guard asli di hadiah-retailer-routing.module.ts (naik-level/list-hadiah, .../form).
              enum: 'REWARD_RETAILER',
              label: 'List Hadiah',
              path: 'hadiah-retailer/naik-level/list-hadiah',
              children: [],
            },
          ],
        },
      ],
    },
  },
];
